import { useNewChat } from "@hooks:useNewChat";
import { Box, IconButton, Tooltip } from "@mui/material";
import { Tab } from "@pages:app/talk/const";
import { Sidebar } from "@pages:app/talk/Sidebar/Sidebar";
import { ReactNode, useState } from "react";
import { BiMessageRoundedAdd } from "react-icons/bi";
import { BsLayoutSidebar } from "react-icons/bs";
import { useLocation, useNavigate } from "react-router";

import { Routes } from "@:constants";

interface TalkProps {
  children?: ReactNode;
}

export const TalkLayout = ({ children }: TalkProps) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { newChat } = useNewChat();
  const [sidebarVisible, setSidebarVisible] = useState(true);

  const tab = location.pathname.includes(Routes.AppSearch)
    ? Tab.Search
    : Tab.Chat;

  const setTab = (newTab: Tab) => {
    if (newTab === Tab.Search) {
      navigate(Routes.AppSearch);
    } else {
      newChat();
    }
  };

  const toggleSidebar = () => {
    setSidebarVisible(!sidebarVisible);
  };

  return (
    <Box
      sx={{
        background: (theme) => theme.palette.background.default,
        minHeight: "100vh",
        height: "100vh",
        display: "flex",
        alignItems: "center",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          width: sidebarVisible ? "275px" : "0px",
          minWidth: sidebarVisible ? "275px" : "0px",
          transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
          overflow: "hidden",
        }}
      >
        <Sidebar tab={tab} setTab={setTab} onToggleSidebar={toggleSidebar} />
      </Box>
      <Box
        sx={{
          height: "100vh",
          minHeight: "100vh",
          padding: "12px",
          display: "flex",
          width: "100%",
          position: "relative",
          transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: "24px",
            left: "24px",
            zIndex: 1000,
            opacity: sidebarVisible ? 0 : 1,
            visibility: sidebarVisible ? "hidden" : "visible",
            transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
            display: "flex",
            flexDirection: "column",
            gap: "8px",
          }}
        >
          <Tooltip title="Show Sidebar" placement="right">
            <IconButton onClick={toggleSidebar}>
              <BsLayoutSidebar size={20} />
            </IconButton>
          </Tooltip>
          <Tooltip title="New Chat" placement="right">
            <IconButton onClick={newChat}>
              <BiMessageRoundedAdd size={20} />
            </IconButton>
          </Tooltip>
        </Box>
        {children}
      </Box>
    </Box>
  );
};
